export default "__VITE_ASSET__HbT5eyhd__"